/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to check uploaded file
 * @export
 * @interface CheckUploadedFileRequest
 */
export interface CheckUploadedFileRequest {
    /**
     * Org emails domain
     * @type {string}
     * @memberof CheckUploadedFileRequest
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckUploadedFileRequest
     */
    expectedTxtRecord?: string;
}

/**
 * Check if a given object implements the CheckUploadedFileRequest interface.
 */
export function instanceOfCheckUploadedFileRequest(value: object): boolean {
    return true;
}

export function CheckUploadedFileRequestFromJSON(json: any): CheckUploadedFileRequest {
    return CheckUploadedFileRequestFromJSONTyped(json, false);
}

export function CheckUploadedFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckUploadedFileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'] == null ? undefined : json['domain'],
        'expectedTxtRecord': json['expectedTxtRecord'] == null ? undefined : json['expectedTxtRecord'],
    };
}

export function CheckUploadedFileRequestToJSON(value?: CheckUploadedFileRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'domain': value['domain'],
        'expectedTxtRecord': value['expectedTxtRecord'],
    };
}

